



























import { PaginationQueryStringMixin } from '@/features/core/components/mixins/pagination-query-string';
import { SpotTableFilterMixin } from '@/features/core/components/mixins/spot-table-filter';
import TreeNodeLocationGeneratorMixin from '@/features/core/components/mixins/tree-node-location-generator';
import { RootGetter } from '@/features/core/store';
import { SpotTableSpot } from '@/features/domain-ui/spot-table/model';
import { SpotsExportSpot } from '@/features/domain-ui/spots-export/model';
import { isDef } from '@/util/lang';
import { StringProp } from '@/util/prop-decorators';
import { Component, Mixins } from 'vue-property-decorator';
import exportSubscription from './export.gql';
import spotsQuery from './spots.gql';
import query from './view.gql';
import {
  AppManagerTreeNodeSpotsViewExportSubscription,
  AppManagerTreeNodeSpotsViewExportSubscriptionVariables,
} from './__generated__/AppManagerTreeNodeSpotsViewExportSubscription';
import {
  AppManagerTreeNodeSpotsViewQuery,
  AppManagerTreeNodeSpotsViewQueryVariables,
} from './__generated__/AppManagerTreeNodeSpotsViewQuery';
import {
  AppManagerTreeNodeSpotsViewSpotsQuery,
  AppManagerTreeNodeSpotsViewSpotsQueryVariables,
} from './__generated__/AppManagerTreeNodeSpotsViewSpotsQuery';

@Component({
  apollo: {
    treeNodes: {
      query,
      pollInterval: 60000,
      fetchPolicy: 'cache-and-network',
      variables(this: SpotsView): AppManagerTreeNodeSpotsViewQueryVariables {
        return this.filterVariables;
      },
    },
    spots: {
      query: spotsQuery,
      pollInterval: 60000,
      fetchPolicy: 'cache-and-network',
      variables(this: SpotsView): AppManagerTreeNodeSpotsViewSpotsQueryVariables {
        return { ...this.spotsVariables, skip: this.skip, take: this.take };
      },
    },
  },
  data() {
    return { treeNodes: undefined, spots: undefined };
  },
})
export default class SpotsView extends Mixins(
  TreeNodeLocationGeneratorMixin,
  PaginationQueryStringMixin,
  SpotTableFilterMixin,
) {
  @StringProp(true)
  private readonly treeNodeId!: string;

  @RootGetter
  private readonly userId?: string;

  private readonly treeNodes?: AppManagerTreeNodeSpotsViewQuery['treeNodes'];
  private readonly spots?: AppManagerTreeNodeSpotsViewSpotsQuery['spots'];

  protected get count(): number {
    return this.spots !== undefined && 'spots' in this.spots.first ? this.spots.first.spots.count : 0;
  }

  private get filterVariables(): AppManagerTreeNodeSpotsViewQueryVariables {
    return {
      treeNodeId: this.treeNodeId,
      roles: this.roles,
      healths: this.healths,
      manufacturers: this.manufacturers,
      attributes: this.attributes,
      userId: this.userId,
    };
  }

  private get spotsVariables(): AppManagerTreeNodeSpotsViewExportSubscriptionVariables {
    return {
      ...this.filterVariables,
      descriptors: [{ start: '-P30D', stop: this.normalizedMetricsStopDate }],
    };
  }

  private onSpotClick(spot: SpotTableSpot): void {
    this.$router.push({
      name: 'AppManager/TreeNode/Spots/Spot',
      params: { treeNodeId: spot.path.items.slice(-1)[0].id, spotId: spot.id },
    });
  }

  private exportSpots(): Promise<SpotsExportSpot[]> {
    return new Promise((resolve) => {
      this.$apollo
        .subscribe<
          AppManagerTreeNodeSpotsViewExportSubscription,
          AppManagerTreeNodeSpotsViewExportSubscriptionVariables
        >({
          query: exportSubscription,
          variables: this.spotsVariables,
        })
        .map(({ data }) => (data?.spot ?? undefined) as SpotsExportSpot)
        .filter(isDef)
        .reduce((spots, spot) => (spots.push(spot), spots), new Array<SpotsExportSpot>())
        .subscribe(resolve);
    });
  }
}
